import { ProductsPage } from "./ProductsPage";

export function ProductionProductsPage() {
  return <ProductsPage catalogMode="production" />;
}
